import Logo from "../../Images/static/media/logos/kalo-logo.svg";

const { REACT_APP_PUBLIC_URL } = process.env;

/* eslint-disable max-len */
function Header() {
  return (
    <header
      id="page-header"
      className="bp-page-header navbar navbar-mainnavigation type-landingnavigation navbar-default navbar-has-image navbar-top autohide"
    >
      <nav aria-label="Hauptnavigation" className="w-100">
        <div className="topnavigation topnavigation-desktop">
          <div className="container">
            <div className="nav-desktop-offset">
              <div id="topnavigation-desktop">
                <ul className="nav nav-tabs" role="tablist">
                  <li className="nav-item">
                    <a
                      href={`${REACT_APP_PUBLIC_URL}/heizkosten/`}
                      className="nav-link active"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="nav-link-text">Heizkosten</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="navigation">
          <div className="container">
            <div className="nav-desktop-offset">
              <a
                className="navbar-brand navbar-brand-image"
                href={`${REACT_APP_PUBLIC_URL}`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="navbar-brand-logo-normal"
                  src={Logo}
                  alt="Heizkosten | KALO - Einfach. Innovativ. Persönlich. logo"
                  height="52"
                  width="180"
                />
              </a>
              <div className="navbar-additional navbar-additional-mobile">
                <button
                  className="navbar-toggler collapsed"
                  type="button"
                  data-toggle="collapse"
                  data-bs-toggle="collapse"
                  data-target="#mainnavigation"
                  data-bs-target="#mainnavigation"
                  aria-controls="mainnavigation"
                  aria-expanded="false"
                  aria-label="Menü ein-/ausklappen"
                >
                  <span className="navbar-toggler-icon" />
                </button>
              </div>
              <div id="mainnavigation" className="collapse navbar-collapse">
                <div className="topnavigation topnavigation-mobile">
                  <div id="topnavigation-mobile">
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <a
                          href={`${REACT_APP_PUBLIC_URL}/heizkosten/`}
                          className="nav-link active"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="nav-link-text">Heizkosten</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="navbar-collapse-inner">
                  {/*
                  <div className="tab-content">
                    <div
                      className="tab-pane active"
                      id="tab-id-149"
                      role="tabpanel"
                      aria-labelledby="nav-item-149"
                    >
                      <ul className="navbar-nav">
                        <li className="nav-item">
                          <a
                            href={`${REACT_APP_PUBLIC_URL}/heizkosten/produktinformationen/`}
                            id="nav-item-175"
                            className="nav-link"
                            title="Produktinformationen"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className="nav-link-text">Produktinformationen</span>
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            href={`${REACT_APP_PUBLIC_URL}/heizkosten/wissenswertes/`}
                            id="nav-item-177"
                            className="nav-link"
                            title="Wissenswertes"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className="nav-link-text">Wissenswertes</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  */}
                  <div className="navbar-additional navbar-additional-mobile mt-2">
                    <p>
                      <a
                        href={`${REACT_APP_PUBLIC_URL}/co2-kosten-rechner/`}
                        className="btn btn-tertiary"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Berechnung neu starten
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="navbar-additional navbar-additional-desktop">
                <div className="buttons">
                  <p>
                    <a
                      href={`${REACT_APP_PUBLIC_URL}/co2-kosten-rechner/`}
                      className="btn btn-tertiary"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Berechnung neu starten
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
